import { Contact } from 'src/app/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  forwardRef,
  Inject,
  ChangeDetectorRef
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { ContactListDataEntity } from '../../../../../models/data-entities/contact-list-data-entity';
import { UntypedFormBuilder, NgForm } from '@angular/forms';
import { ContactEmailAddress, ContactAddress } from '../../../../../models';
import { ClientService, WorkflowContextService } from '../../../../../services';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

//Started by vipul on 18/12/2025
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TemplateRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/services/layout.service';
//End by vipul on 18/12/2025


@Component({
    selector: 'wm-contact-list-data-entity-input',
    templateUrl: './contact-list-data-entity-input.component.html',
    styleUrls: ['./contact-list-data-entity-input.component.css'],
    standalone: false
})
export class ContactListDataEntityInputComponent
  extends DataEntityInputComponent
  implements OnInit {
  @Input() entity: ContactListDataEntity;
  templateForPermitForm: boolean = false;         // Added by Vipul on 17/12/2025
  @ViewChild('content') content!: TemplateRef<any>;         // Added by Vipul on 18/12/2025
  dialogRef!: MatDialogRef<any>;         // Added by Vipul on 18/12/2025
  // constructor(
  //   componentFactoryResolver: ComponentFactoryResolver,
  //   private _fb: FormBuilder
  //   )
  constructor(
    public layoutService: LayoutService,
    //  _dataSvc: DataService,
    componentFactoryResolver: ComponentFactoryResolver,
    @Inject(forwardRef(() => ClientService)) public _clientSvc: ClientService,
    @Inject(forwardRef(() => WorkflowContextService))
    private _context: WorkflowContextService,
    @Inject(forwardRef(() => ActivatedRoute)) private route: ActivatedRoute,
    private _fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private dialog: MatDialog,    //Added by vipul on 18/12/2025
    ref: ChangeDetectorRef
  ) {
    super(layoutService,componentFactoryResolver, ref, _context);
    // Started by Vipul on 17/12/2025
 layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 17/12/2025
  }
  // constructor(
  // componentFactoryResolver: ComponentFactoryResolver,
  //   private _clientSvc: ClientService,
  //   private route: ActivatedRoute
  //  )

  // {
  // super(componentFactoryResolver);

  // }
  onFormSubmit(form: NgForm) {}

  open(content) {

    if (this.templateForPermitForm) {
      this.dialogRef = this.dialog.open(this.content, {
        width: '600px'
      });
    } else {
      this.modalService.open(content, { ariaLabelledBy: 'modal-contact' });
    }
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }


  ngOnInit() {
    //get the contact //this is messy, but it's because it's the way shawn implemnted it in contactdetalview.
    //this should all be moved down to the getContact service layer.
    this.route.params.subscribe(params => {
      if ((this.entity.selectedContactId || '') != '') {
        const z = this._clientSvc.getContact(this.entity.selectedContactId);

        z.pipe(
          map(contact => {
            this.entity.selectedContact = contact;
            if (this.entity.selectedContact.emailAddress == null) {
              this.entity.selectedContact.emailAddress = new ContactEmailAddress();
            }
            if (this.entity.selectedContact.address == null) {
              this.entity.selectedContact.address = new ContactAddress();
            }
            return this.entity.selectedContact;
          })
        ).subscribe(res => {
          this.entity.selectedContact = res;
        });
      } else {
        this.entity.selectedContact = this._clientSvc.createContact();
      }
    });
  }

  getOfficeHours(contact: Contact) {
    return contact.officeHours.replace(new RegExp('\n', 'g'), '<br />');
  }

  // Started by Vipul on 19/12/2025
  get addressLines(): string[] {
    const address = this.entity?.selectedContact?.address;
    if (!address) return [];

    return [
      address.address1,
      address.address2,
      address.city && address.state
        ? `${address.city}, ${address.state} ${address.zip}`
        : null
    ].filter(Boolean) as string[];
  }

  // Started by Vipul on 19/12/2025
}
